<badge *ngIf="showAiTrialBadge$ | async"
	class="practice-badge"
	[badgeColor]="BadgeColors.SUCCESS"
	[badgeLabel]="getMessageTranslation()">
</badge>
